import _ from 'lodash';
import React, { useMemo } from 'react';
import { JqueryClassFaker } from './JqueryClassFaker';

const buttonClasses = {
	'default': 'default',
	'block': 'btn-block',
	'danger': 'danger',
	'moneyButton': 'money_button',
	'flat': 'btn-flat',
	'selected': 'selected',
	'glow': 'pulse_glow',
	'bright': 'bright',
	'dark': 'dark',
	'small': 'btn-small',
	'active': 'active',
	'success': 'success',
};

const Button = React.forwardRef(function Button(props, ref) {
		const { children, className, submit, ...hangingProps } = props;

		const { remainingProps, classes } = useMemo(() => {
			const classes = new JqueryClassFaker();
			const remainingProps = { ...hangingProps };
			_.each(buttonClasses, (className, propKey) => {
				if(props[propKey] === undefined) {
					return;
				}
				classes.toggleClass(className, props[propKey]);
				delete remainingProps[propKey];
			});
			classes.add(className);
			return { classes, remainingProps };
		});

		/** ui-button carries the shared look, css/_buttons.scss. */
		const classToUse = `btn ui-button waves-effect ${classes.toString()} z-depth-0`;
		return (
			<button
				type={submit ? 'submit' : 'button'}
				className={classToUse}
				{...remainingProps}
				ref={ref}
			>
				{children}
			</button>
		);
	}
);


export default Button;
